import React from 'react';
import EditPencilIcon from '@static/images/swimRegistration/edit-pencil-icon.svg';

// eslint-disable-next-line import/prefer-default-export
export const METADATA_SUB_GROPUP_SCORING_COLUMNS = ({
  handleEditScoringDetails,
  isEditableAccess
}) => [
  {
    Header: 'Group ID',
    accessor: 'groupID',
    className: 'notranslate'
  },
  {
    Header: 'Group Name',
    accessor: 'groupName',
    className: 'notranslate'
  },
  {
    Header: 'Subgroup ID',
    accessor: 'subgroupID',
    className: 'notranslate ymca-word-break ymca-ellipse'
  },
  {
    Header: 'Subgroup Name',
    accessor: 'subgroupName',
    className: 'notranslate ymca-word-break ymca-ellipse'
  },
  {
    Header: 'Subgroup Type',
    accessor: 'subGroupType',
    className: 'notranslate ymca-word-break ymca-ellipse'
  },
  {
    Header: 'Data Eval Level',
    accessor: 'dataEvalLevel',
    className: 'notranslate ymca-word-break ymca-ellipse'
  },
  {
    Header: 'Points Possible',
    accessor: 'pointsPossible',
    className: 'notranslate ymca-word-break ymca-ellipse'
  },
  {
    Header: 'Min. Points Req',
    accessor: 'minPointsReq',
    className: 'notranslate ymca-word-break ymca-ellipse'
  },

  {
    Header: 'Earned Score',
    accessor: 'earnedScore',
    className: 'notranslate ymca-word-break ymca-ellipse'
  },
  {
    Header: 'Actions',
    accessor: 'isHidden',
    className: 'hide',
    Cell: v => (
      <div className="d-flex">
        {!isEditableAccess ? (
          <button
            className="btn table-link"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
            type="button"
            onClick={() => handleEditScoringDetails(v)}
          >
            <img
              src={EditPencilIcon}
              className="me-2 mb-1"
              alt="edit-pencil-icon"
            />
          </button>
        ) : (
          '-'
        )}
      </div>
    )
  }
];
